/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_delivery_range = /** @type {(inputs: { min_date: NonNullable<unknown>, max_date: NonNullable<unknown> }) => string} */ (i) => {
	return `Doručeno mezi ${i.min_date} a ${i.max_date}`
};

const en_order_delivery_range = /** @type {(inputs: { min_date: NonNullable<unknown>, max_date: NonNullable<unknown> }) => string} */ (i) => {
	return `Delivered between ${i.min_date} and ${i.max_date}`
};

const fr_order_delivery_range = /** @type {(inputs: { min_date: NonNullable<unknown>, max_date: NonNullable<unknown> }) => string} */ (i) => {
	return `Livré entre le ${i.min_date} et le ${i.max_date}`
};

const hu_order_delivery_range = /** @type {(inputs: { min_date: NonNullable<unknown>, max_date: NonNullable<unknown> }) => string} */ (i) => {
	return `Szállítás ${i.min_date} és ${i.max_date} között`
};

/** @type {(inputs: { min_date: NonNullable<unknown>, max_date: NonNullable<unknown> }) => string} */
const da_order_delivery_range = en_order_delivery_range;

/** @type {(inputs: { min_date: NonNullable<unknown>, max_date: NonNullable<unknown> }) => string} */
const de_order_delivery_range = en_order_delivery_range;

/** @type {(inputs: { min_date: NonNullable<unknown>, max_date: NonNullable<unknown> }) => string} */
const es_order_delivery_range = en_order_delivery_range;

/** @type {(inputs: { min_date: NonNullable<unknown>, max_date: NonNullable<unknown> }) => string} */
const it_order_delivery_range = en_order_delivery_range;

/** @type {(inputs: { min_date: NonNullable<unknown>, max_date: NonNullable<unknown> }) => string} */
const nl_order_delivery_range = en_order_delivery_range;

/** @type {(inputs: { min_date: NonNullable<unknown>, max_date: NonNullable<unknown> }) => string} */
const pl_order_delivery_range = en_order_delivery_range;

/** @type {(inputs: { min_date: NonNullable<unknown>, max_date: NonNullable<unknown> }) => string} */
const pt_order_delivery_range = en_order_delivery_range;

/** @type {(inputs: { min_date: NonNullable<unknown>, max_date: NonNullable<unknown> }) => string} */
const sv_order_delivery_range = en_order_delivery_range;

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ min_date: NonNullable<unknown>, max_date: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const order_delivery_range = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_delivery_range(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_delivery_range", locale)
	if (locale === "cs") return cs_order_delivery_range(inputs)
	if (locale === "da") return da_order_delivery_range(inputs)
	if (locale === "de") return de_order_delivery_range(inputs)
	if (locale === "en") return en_order_delivery_range(inputs)
	if (locale === "es") return es_order_delivery_range(inputs)
	if (locale === "fr") return fr_order_delivery_range(inputs)
	if (locale === "hu") return hu_order_delivery_range(inputs)
	if (locale === "it") return it_order_delivery_range(inputs)
	if (locale === "nl") return nl_order_delivery_range(inputs)
	if (locale === "pl") return pl_order_delivery_range(inputs)
	if (locale === "pt") return pt_order_delivery_range(inputs)
	return sv_order_delivery_range(inputs)
};